export default __webpack_public_path__ + "static/media/business_show_4_en.08981956.png";